import './style.scss';
import { WorkHistoryModal } from './WorkHistoryModal/WorkHistoryModal';
import { Slider } from '../../../js/components/Slider/Slider';
import { showOrderModal } from '../../popups/v1/OrderModal/scripts'

export default !function () {
  const mainBlock = document.querySelector('.work-v4');

  if (!mainBlock) {
    return;
  }

  const desktop = window.matchMedia('(min-width: 1024px)');
  const tablet = window.matchMedia('(min-width: 768px)');
  const cardsBlock = mainBlock.querySelector('.work-v4-expectations');

  // Get consultation button
  const buttonConsult = mainBlock.querySelector('.work-v4__button');

  if (buttonConsult) {
    const blockName = buttonConsult.closest('[data-block-name]')?.dataset.blockName || 'Блок без названия'
    const buttonType = buttonConsult.dataset.actionButton || (buttonConsult.dataset.redirectLink && 'redirect')

    buttonConsult.addEventListener('click', (evt) => {
      evt.preventDefault();

      if (buttonType) {
        if (buttonType === 'order-modal') {
          showOrderModal({ blockName })
        }

        window.$analytics?.push('all-block-consult-button-click', {
          blockName,
          buttonType,
          buttonText: buttonConsult.textContent
        })
      }
    });
  }

  // Stacking cards
  const cards = [...document.querySelectorAll('.work-v4-expectations__item')];

  cards.forEach((card) => {
    if (desktop.matches) {
      card.addEventListener('mouseenter', (evt) => {
        const titleBlock = evt.target.querySelector('.work-v4-expectations__subtitle');

        if (titleBlock) {
          window.$analytics && window.$analytics.push('work-card-mouseenter', {
            title: titleBlock.innerText
          });
        }
      });
    }
  });

  const stackingCards = () => {
    if (cardsBlock) {
      let cardOffset = 12; // отступ на который нижняя карточка сдвинута
      let marginBetween = 8; // расстояние между карточками
      let marginBottom = 42; // отступ от блока с карточками до следующего. дублируется в ссs - если меняется нужно менять и в .expectations__card

      if (tablet.matches) {
        cardOffset = 98;
        marginBetween = 16;
        marginBottom = 136; // дублируется в ссs - если меняется нужно менять и в .expectations__card
      }

      // величина сдвига - отступ между карточками
      const visibleMargin = cardOffset - marginBetween;

      // высоты реальных карточек
      const heights = cards.map(card => {
        return card.querySelector('.work-v4-expectations__card').offsetHeight;
      });

      // высота самой большой карточки
      const maxHeight = Math.max(...heights);

      // задаем оберткам размер самой большой карточки чтобы когда все карточки настакались уезжали всем стаком
      cards.forEach((item, i) => {
        if (!desktop.matches) {
          item.style.height = `${maxHeight}px`;

          if (i < cards.length - 1) {
            // расчитывается для следующей карточки в зависимости от текущей
            // высота реальной карточки - высота обертки(высота самой большой карточки) - визульный сдвиг
            cards[i + 1].style.marginTop = `${heights[i] - maxHeight - visibleMargin}px`;
          }
        }
      });

      // величина в translate * количество карточек - 1 (т.к первая стакается в свое место) + отступ в макете
      cardsBlock.style.marginBottom = `${cardOffset * (cards.length - 1) + marginBottom}px`;
    }
  }

  const clearStackingCards = () => {
    if (cardsBlock) {
      cards.forEach((item, i) => {
        cards[i].removeAttribute('style');
      });

      cardsBlock.removeAttribute('style');
    }
  }

  const initSwiper = () => {
    if (cardsBlock) {
      const options = {
        wrapper: cardsBlock,
        settings: {
          loop: false,
          slideClass: 'work-v4-expectations__item',
          wrapperClass: 'work-v4-expectations__list',
          spaceBetween: 16,
          slidesPerGroup: 2,

          breakpoints: {
            1280: {
              slidesPerGroup: 3,
            }
          },

          pagination: {
            el: '.work-v4-expectations__count',
            currentClass: 'controls__current',
            type: 'fraction',
          },

          navigation: {
            nextEl: '.work-v4-expectations__arrow-next',
            prevEl: '.work-v4-expectations__arrow-prev'
          }
        },
        modules: ['navigation', 'pagination'],
        initCondition: {
          md: false,
          lg: cards.length > 2,
          xl: cards.length > 3
        },
        controls: cardsBlock.querySelector('.work-v4-expectations__controls'),
        isFocusable: true
      };

      new Slider(options).init();
    }
  };

  // «Читать истории»
  const storiesButton = mainBlock.querySelector('.work-v4-stories__button');
  const popupTemplate = mainBlock.querySelector('#work-v4-stories');

  if (storiesButton && popupTemplate) {
    const popup = popupTemplate.content.querySelector('.work-v4-popup__wrapper');

    storiesButton.addEventListener('click', () => {
      new WorkHistoryModal(popup).init();

      window.$analytics && window.$analytics.push('work-stories-popup-button-click');
    });
  }

  // Сторис
  const stories = mainBlock.querySelectorAll('.work-v4-stories__item');

  if (stories.length > 1) {
    // Сторис -- анимация
    const duration = 240; // длина анимации, в ms
    const animationPause = 3000; // длина паузы на одной сторис, в ms
    const totalDuration = animationPause * stories.length;

    // Считаем задержки для анимации, в сотых
    // простые пропорции: x = 100% × кусочек / целое
    // для перевода в сотые надо делить на сто
    // поэтому просто убираем 100 из формулы выше
    const pause = animationPause / totalDuration;
    const offset = duration / totalDuration;
    const offsetFade = offset + pause;
    const offsetAppear = 1 - offset;

    const animateAppearance = (el, delay) => {
      el.animate([
        { opacity: 0, zIndex: -1 },
        { opacity: 0, zIndex: 1, offset: 0.001 },
        { opacity: 1, offset: offset },
        { opacity: 1, offset: pause },
        { opacity: 0, offset: offsetFade },
        { opacity: 0, offset: offsetAppear },
        { opacity: 1 }
      ], {
        duration: totalDuration,
        delay: delay,
        iterations: 1,
        fill: 'forwards'
      });
    }

    const animatePhoto = (el, delay) => {
      el.animate([
        { opacity: 1 },
        { opacity: 1, offset: pause },
        { opacity: 0, offset: offsetFade },
        { opacity: 0, offset: offsetAppear },
        { opacity: 1 }
      ], {
        duration: totalDuration,
        delay: delay,
        iterations: Infinity,
        fill: 'forwards'
      });
    }

    const animateBar = (el, pause, wait) => {
      el.animate([
        { transform: 'translateX(-100%)' },
        { transform: 'translateX(-100%)', offset: pause },
        { transform: 'translateX(0)', offset: wait },
        { transform: 'translateX(0)' }
      ], {
        duration: totalDuration,
        iterations: Infinity,
        fill: 'forwards'
      });
    }

    // Сторис -- плашечки
    const addIndicators = (amount) => {
      const indicatorsList = mainBlock.querySelector('.work-v4-stories__loading');
      let fragment = document.createDocumentFragment();

      for (let i = 0; i < amount; i++) {
        const item = document.createElement('li');
        const bar = document.createElement('div');

        item.classList.add('work-v4-stories__indicator');
        bar.classList.add('work-v4-stories__bar');

        const barDelay = i * pause; // сколько ждем до того, как начать анимировать
        const barWait = barDelay + pause; // когда заканчиваем анимировать

        animateBar(bar, barDelay, barWait);

        item.appendChild(bar);
        fragment.appendChild(item);
      }

      indicatorsList.appendChild(fragment);
    }

    // Сторис -- собираем всё вместе
    for (let i = 0; i < stories.length; i++) {
      const firstDelay = animationPause * i;
      const delay = firstDelay + totalDuration;

      try {
        // error in firefox 70- -> Animation to or from an underlying value is not yet supported
        // не поддерживается свойство zIndex
        animateAppearance(stories[i], firstDelay);
      } catch (e) {} // eslint-disable-line

      animatePhoto(stories[i], delay);
    }

    addIndicators(stories.length);
  }

  // Media change
  const mediaChangeListenerDesktop = () => {
    if (desktop.matches) {
      clearStackingCards();

      initSwiper();
    } else if (tablet.matches) {
      stackingCards();
    }
  };

  const mediaChangeListenerTablet = () => {
    if (!desktop.matches && tablet.matches) {
      clearStackingCards();
      stackingCards();

    } else if (!tablet.matches) {
      stackingCards();
    }
  }

  const createSocialLinksListeners = () => {
    const links = [...document.querySelectorAll('.work-v4-popup__link')];

    links.forEach((link) => {
      link.addEventListener('click', () => {
        window.$analytics && window.$analytics.push('work-stories-social-click', {
          socialName: link.dataset.socialName
        });
      });
    });
  };

  createSocialLinksListeners();

  // небольшой таймаут на FOUC
  setTimeout(mediaChangeListenerDesktop, 200);
  setTimeout(mediaChangeListenerTablet, 200);

  tablet.addEventListener('change', mediaChangeListenerTablet);
  desktop.addEventListener('change', mediaChangeListenerDesktop);
}();
